<template>
  <div class="logo_wrap">
    <img :src="mask_logo" alt="" class="left mask" />
    <img :src="mask_logo" alt="" class="right mask" />
    <div class="line_odd">
      <img :src="logo1" alt="" class="logo_img" />
      <img :src="logo1" alt="" class="logo_img" />
    </div>
    <div class="line_even">
      <img :src="logo2" alt="" class="logo_img" />
      <img :src="logo2" alt="" class="logo_img" />
    </div>
  </div>
</template>

<script>
import logo1 from "@/assets/images/icons/newhome/case1.png";
import logo2 from "@/assets/images/icons/newhome/case2.png";
import mask_logo from "@/assets/images/icons/newhome/mask_logo.png";

export default {
  name: "HomeCases",
  props: {},
  data() {
    return { logo1, logo2, mask_logo };
  },
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.logo_wrap {
  position: relative;
  width: 1440px;
  overflow: hidden;
  margin: 0 auto;
  font-size: 0;

  .mask {
    position: absolute;
    z-index: 10;
  }

  .left {
    left: 0;
  }

  .right {
    right: -1px;
    transform: rotate(180deg);
  }

  .line_odd .logo_img {
    width: 50%;
    display: inline-block;
    height: 425px;
  }

  .line_even .logo_img {
    width: 50%;
    display: inline-block;
    height: 425px;
  }

  .line_even {
    width: 5760px;
    -webkit-animation: scrollToLeft 30s linear infinite;
    animation: scrollToLeft 30s linear infinite;
  }

  .line_odd {
    width: 5760px;
    -webkit-animation: scrollToRight 30s linear infinite;
    animation: scrollToRight 30s linear infinite;
  }
}
@-webkit-keyframes scrollToRight {
  from {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }
}

@keyframes scrollToRight {
  from {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }
}

@-webkit-keyframes scrollToLeft {
  from {
    -webkit-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }

  to {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
  }
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .logo_wrap {
    width: 1200px;
    .line_odd .logo_img {
      height: 319px;
    }

    .line_even .logo_img {
      height: 319px;
    }

    .line_even,
    .line_odd {
      width: 4384px;
    }
  }
}
</style>
